(function ($) {

  if($('.section--slider-6').length) {
    $('.section--slider-6 .slides-image-wrapper .slider-wrapper').on('afterChange', function (event, slick, nextSlide) {
      updateprogressbar(nextSlide);
    });

    if ($('.section--slider-6 .slides-image-wrapper .slider-wrapper').length) {

      $('.section--slider-6 .slides-image-wrapper .slider-wrapper').slick({
        arrows: false,
        dots: false,
        infinite: false,
        slide: '.card--icon-title-desc-link',
        slidesToShow: 1.2,
        slidesToScroll: 1,
        initialSlide: 0,
        adaptiveHeight: true,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 620,
            settings: {
              arrows: false,
              slidesToShow: 2
            }
          },
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              slidesToShow: 2.3
            }
          }
        ]
      });
    }

    let updateprogressbar = function (nextSlide) {

      let index = parseInt(nextSlide) + 1;
      let totalSlide = $(".section--slider-6 .card--icon-title-desc-link").not('.slick-cloned').length;
      let progress = (index / totalSlide) * 100;

      $('.section--slider-6 .slider-progress').width(progress + '%');

      $('.section--slider-6 .slider-current-index').html(index < 10 ? '0' + index : index);
    }

    $('.section--slider-6 .slider-next').click(function (e) {
      e.preventDefault();
      $('.section--slider-6 .slides-image-wrapper .slider-wrapper').slick('slickNext');
    });

    $('.section--slider-6 .slider-prev').click(function (e) {
      e.preventDefault();
      $('.section--slider-6 .slides-image-wrapper .slider-wrapper').slick('slickPrev');
    });
  }

})(jQuery);
